import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    backgroundColor: theme.palette.custom.pageBackground,
    // Also what makes the two native date inputs in the filter bar render dark:
    // <input type="date"> is drawn by the browser and only follows color-scheme.
    colorScheme: theme.palette.type,
    '& .MuiPaper-root': {
      elevation: 3,
    },
    width: '100%',
    overflowX: 'auto',
  },
  table: {
    minWidth: '2200px',
  },
  header: {
    display: 'flex',
    paddingBottom: '40px',
  },
  title: {
    flexGrow: 1,
    letterSpacing: '-0.5px',
  },
  subtitle: {
    marginLeft: '1rem',
    position: 'relative',
    top: '1rem',
  },
  filtersContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: '10px',
  },
  filtersId: {
    marginRight: '1rem',
    marginBottom: '1rem',
    minWidth: '1rem',
    width: '8rem',
  },
  filtersSucursal: {
    marginRight: '1rem',
    marginBottom: '1rem',
    minWidth: '200px',
  },
  filtersEncuesta: {
    marginRight: '1rem',
    marginBottom: '1rem',
    minWidth: '200px',
  },
  filtersDateStart: {
    marginRight: '1rem',
    marginBottom: '1rem',
    minWidth: '3rem',
  },
  filtersDateEnd: {
    marginRight: '1rem',
    marginBottom: '1rem',
    minWidth: '3rem',
  },
  filtersEmail: {
    marginRight: '3rem',
    marginBottom: '1rem',
    minWidth: '3rem',
    width: '17rem',
  },
  locationName: {
    // '#22617B' is exactly `primary.mainBlue`, which already has a dark value.
    color: theme.palette.primary.mainBlue,
    paddingLeft: '1%',
    fontWeight: 'bold',
    marginLeft: '10px',
  },
  titleField: {
    color: theme.palette.primary.mainBlue,
    paddingLeft: '1%',
    fontWeight: 'bold',
    marginLeft: '10px',
    textDecoration: 'none',
  },
  userEmail: {
    color: theme.palette.primary.mainBlue,
    paddingLeft: '1%',
    fontWeight: 'bold',
    marginLeft: '10px',
  },
  taskResponseTable: {
    width: '100%',
    overflowX: 'auto',
  },
  tableHeader: {
    textAlign: 'center',
  },
  taskNameHeader: {
    textAlign: 'left',
  },
  progress: {
    height: '610px',
    display: 'table-cell',
    textAlign: 'center',
    padding: '50px',
    '& div': {
      color: theme.palette.primary.main,
    },
    '& h4': {
      color: theme.palette.primary.main,
      fontWeight: '200',
    },
  },
  tag: {
    borderRadius: '5px',
    padding: '5px 8px',
    maxWidth: '160px',
    margin: '0px auto',
  },
  // NOTE: none of the tag* classes below are applied anywhere in this module —
  // the live status column renders inline `successIcon`/`errorText` spans in
  // index.js instead. They are migrated anyway so that re-wiring them does not
  // reintroduce pastel chips on a dark surface.
  tagOpen: {
    color: theme.palette.custom.statusOpenText,
    backgroundColor: theme.palette.custom.statusOpenBackground,
  },
  tagWaitinfForApproval: {
    color: theme.palette.custom.statusClosedText,
    backgroundColor: theme.palette.custom.statusClosedBackground,
  },
  tagApproved: {
    color: theme.palette.custom.statusApprovedText,
    backgroundColor: theme.palette.custom.statusApprovedBackground,
  },
  tagProcessing: {
    color: theme.palette.custom.statusNeutralText,
    backgroundColor: theme.palette.custom.statusNeutralBackground,
  },
  tagClose: {
    color: theme.palette.custom.statusRejectedText,
    backgroundColor: theme.palette.custom.statusRejectedBackground,
  },
  tagObjected: {
    color: theme.palette.custom.statusPendingText,
    backgroundColor: theme.palette.custom.statusPendingBackground,
  },
  // Deliberately mixed: red label on the peach fill, as in the original.
  tagRejected: {
    color: theme.palette.custom.statusRejectedText,
    backgroundColor: theme.palette.custom.statusPendingBackground,
  },
  tagPendingDate: {
    color: theme.palette.custom.statusIdleText,
    backgroundColor: theme.palette.custom.statusIdleBackground,
  },
  tagNA: {
    color: theme.palette.custom.statusIdleText,
    backgroundColor: theme.palette.custom.statusIdleBackground,
  },
}));

export default useStyles;
